import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    fallbackLng: 'pt',
    resources: {
        pt: {
            translations: require('./locales/pt/translations.json'),
        },
        en: {
            translations: require('./locales/en/translations.json'),
        },
    },
    ns: ['translations'],
    defaultNS: 'translations',
});

export default i18n;
